import * as z from 'zod';

const geographiesBasePath = 'geographies/v1/';

const countrySchema = z.object({
  code: z.string(),
  name: z.string(),
});
export type GeographyCountry = z.infer<typeof countrySchema>;

const regionSchema = z.object({
  code: z.string(),
  name: z.string(),
  countries: z.array(countrySchema),
});
export type GeographyRegion = z.infer<typeof regionSchema>;

export const getRegionsResponseSchema = z.object({
  regions: z.array(regionSchema),
});
export type GetRegionsResponse = z.infer<typeof getRegionsResponseSchema>;

const geographyResultTypeZodEnum = z.enum(['region', 'country']);
export type GeographyResultType = z.infer<typeof geographyResultTypeZodEnum>;

const geographySearchResultSchema = z.object({
  code: z.string(),
  name: z.string(),
  type: geographyResultTypeZodEnum,
});
export type GeographySearchResult = z.infer<typeof geographySearchResultSchema>;

export const searchGeographiesResponseSchema = z.object({
  results: z.array(geographySearchResultSchema),
});
export type SearchGeographiesResponse = z.infer<
  typeof searchGeographiesResponseSchema
>;

export const postSuggestedGeographiesRequestSchema = z.object({
  entity_tags: z.array(z.string()).optional(),
});
export type PostSuggestedGeographiesRequest = z.infer<
  typeof postSuggestedGeographiesRequestSchema
>;

const suggestedGeographySchema = z.object({
  code: z.string(),
  name: z.string(),
  type: geographyResultTypeZodEnum,
});
export type SuggestedGeography = z.infer<typeof suggestedGeographySchema>;

export const postSuggestedGeographiesResponseSchema = z.object({
  suggestions: z.array(suggestedGeographySchema),
});
export type PostSuggestedGeographiesResponse = z.infer<
  typeof postSuggestedGeographiesResponseSchema
>;

export const geographies = {
  getRegions: {
    path: `${geographiesBasePath}regions`,
    schema: getRegionsResponseSchema,
  },
  searchGeographies: {
    path: (query: string, limit?: number) => {
      const params = new URLSearchParams({ q: query });

      if (limit !== undefined) {
        params.set('limit', String(limit));
      }

      return `${geographiesBasePath}search?${params.toString()}`;
    },
    schema: searchGeographiesResponseSchema,
  },
  postSuggested: {
    path: `${geographiesBasePath}suggested`,
    schema: postSuggestedGeographiesResponseSchema,
  },
};
